import TextMarquee from '@/components/ui/text-marque';

export const BenefitsMarqueeSection = () => {
  return (
    <section className="py-12 bg-surface overflow-hidden">
      <div className="space-y-6">
        <TextMarquee baseVelocity={-1.5} clasname="text-accent/70 text-6xl md:text-8xl lg:text-9xl">
          Smart Assets • Secure Investment • Performance Metrics • Revenue Sharing • Innovation Access • Industrial Robotics
        </TextMarquee>

        <TextMarquee baseVelocity={1.5} clasname="text-secondary/60 text-6xl md:text-8xl lg:text-9xl">
          Operational Efficiency • Asset Management • Flexible Investment • Strategic Partnerships • Automated Production • Access Liquidity
        </TextMarquee>
      </div>
    </section>
  );
};
